import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import state from './state';

const InterestsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
export default InterestsStore;
